import React from 'react';

const statuses = {
    'Capturado': {
        text: 'Pendente',
        color: 'warning'
    },
    'Cancelado': {
        text: 'Cancelada',
        color: 'danger'
    },
    'Confirmado': {
        text: 'Finalizado',
        color: 'success'
    },
    'Não Classificado': {
        text: 'Não Classificado',
        color: 'warning'
    },
    'Lançamentos Futuros': {
        text: 'Lançamentos Futuros',
        color: 'info'
    },
    'DEFAULT': {
        text: 'Desconhecido',
        color: 'default'
    }
};

export default function StatusBadge({ status }) {
    const badge = statuses[status] || statuses['DEFAULT']; 
    return (
        <span className={`badge badge-${badge.color}`}>{badge.text}</span>
    );
}


// WEBPACK FOOTER //
// ./src/ZWallet/Operations/components/StatusBadge.js